@if (!platformService.hasWebBleSupport || showNoBleFallback()) {
  <!-- Android App Store / Intent Gate -->
  <div
    data-testid="iglookey-gate"
    class="flex min-h-dvh w-full flex-col items-center justify-center p-6 text-center"
    [style.background-color]="brand.pageBgColor"
    [style.color]="brand.pageFgColor"
  >
    <div class="flex max-w-sm flex-col items-center gap-6">
      <!-- Igloo Brand Logo (with text) -->
      <svg
        width="146"
        height="40"
        viewBox="0 0 73 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="select-none"
      >
        <path
          d="M0 5.43044V19.994H14.5979C17.6048 19.994 20.0411 17.5635 20.0411 14.5636V0H5.44322C2.43622 0 0 2.43051 0 5.43044ZM14.5282 18.1691C12.5208 18.1691 10.8948 16.5469 10.8948 14.5441C10.8948 12.5414 12.5208 10.9192 14.5282 10.9192C16.5357 10.9192 18.1617 12.5414 18.1617 14.5441C18.1617 16.5469 16.5357 18.1691 14.5282 18.1691ZM18.1812 1.83885V9.12759H10.8753C10.8753 5.10267 14.1468 1.83885 18.1812 1.83885ZM9.14628 1.83885V18.1718H1.81812V5.48878C1.81812 3.47215 3.45526 1.83885 5.47663 1.83885H9.14628Z"
          fill="currentColor"
        />
        <path
          d="M27.9775 5.18652H27.3343C26.5046 5.18652 25.8336 5.85595 25.8336 6.68371V15.9141C25.8336 16.2196 26.0842 16.4696 26.3905 16.4696H27.9775C28.2921 16.4696 28.5483 16.2141 28.5483 15.9002V5.75874C28.5483 5.44485 28.2921 5.1893 27.9775 5.1893V5.18652Z"
          fill="currentColor"
        />
        <path
          d="M46.014 0.0065918H45.3708C44.5411 0.0065918 43.8701 0.676024 43.8701 1.50378V15.9146C43.8701 16.2201 44.1207 16.4701 44.427 16.4701H46.014C46.3286 16.4701 46.5848 16.2146 46.5848 15.9007V0.578804C46.5848 0.264921 46.3286 0.00937011 46.014 0.00937011V0.0065918Z"
          fill="currentColor"
        />
        <path
          d="M27.1888 0.295166C26.1586 0.295166 25.3177 1.13126 25.3177 2.16179C25.3177 3.19233 26.1558 4.02842 27.1888 4.02842C28.2217 4.02842 29.0598 3.19233 29.0598 2.16179C29.0598 1.13126 28.2217 0.295166 27.1888 0.295166Z"
          fill="currentColor"
        />
        <path
          d="M53.9632 4.93091C50.7752 4.93091 48.1803 7.51974 48.1803 10.7002C48.1803 13.8807 50.7752 16.4696 53.9632 16.4696C57.1512 16.4696 59.7461 13.8807 59.7461 10.7002C59.7461 7.51974 57.1512 4.93091 53.9632 4.93091ZM53.9938 13.8557C52.2676 13.8557 50.8615 12.453 50.8615 10.7308C50.8615 9.0086 52.2648 7.60585 53.9938 7.60585C55.7229 7.60585 57.1261 9.00582 57.1261 10.7308C57.1261 12.4558 55.7229 13.8557 53.9938 13.8557Z"
          fill="currentColor"
        />
        <path
          d="M66.8093 4.93091C63.6213 4.93091 61.0264 7.51974 61.0264 10.7002C61.0264 13.8807 63.6213 16.4696 66.8093 16.4696C69.9972 16.4696 72.5922 13.8807 72.5922 10.7002C72.5922 7.51974 69.9972 4.93091 66.8093 4.93091ZM66.8399 13.8557C65.1137 13.8557 63.7076 12.453 63.7076 10.7308C63.7076 9.0086 65.1109 7.60585 66.8399 7.60585C68.5689 7.60585 69.9722 9.00582 69.9722 10.7308C69.9722 12.4558 68.5661 13.8557 66.8399 13.8557Z"
          fill="currentColor"
        />
        <path
          d="M41.4972 5.21701H40.6063C40.0327 5.21701 39.5399 5.55312 39.3116 6.03922C39.1306 5.90867 38.9468 5.78367 38.7492 5.67534C37.886 5.18924 36.9032 4.93091 35.9064 4.93091C32.7185 4.93091 30.1235 7.51974 30.1235 10.7002C30.1235 13.8807 32.7185 16.4696 35.9064 16.4696C36.8475 16.4696 37.783 16.239 38.6099 15.8001C38.8076 15.6946 38.9942 15.5779 39.1779 15.4557C39.1779 16.5168 38.3176 17.3751 37.2568 17.3779H37.0925C36.3213 17.3779 35.6976 18.0029 35.6976 18.7723V19.5001C35.6976 19.775 35.9204 20 36.1988 20H37.6939C40.0717 20 42.0012 18.0779 42.0012 15.7029V5.71423C42.0012 5.43923 41.7784 5.21423 41.5 5.21423L41.4972 5.21701ZM38.248 12.628C37.6048 13.4696 36.5997 13.9252 35.5278 13.8502C33.9909 13.7418 32.7463 12.4946 32.6377 10.9613C32.5069 9.13638 33.9575 7.61141 35.7589 7.61141C36.7445 7.61141 37.6494 8.05862 38.248 8.83916C38.6684 9.38637 38.8884 10.0419 38.8884 10.7336C38.8884 11.4252 38.6656 12.0808 38.2452 12.628H38.248Z"
          fill="currentColor"
        />
      </svg>
      <div class="mt-6 flex flex-col gap-2">
        <h1 class="font-sans text-2xl font-bold tracking-tight">iglooKey Failed to Open</h1>
        <p class="text-base opacity-90">Please open the iglooKey with the app</p>
      </div>
      <button
        (click)="openInApp()"
        class="mt-8 cursor-pointer text-lg font-bold underline decoration-2 underline-offset-4 transition-opacity hover:opacity-90 focus:outline-none"
      >
        OPEN APP
      </button>
    </div>
  </div>
}

<div
  class="relative flex min-h-0 w-full flex-1 flex-col transition-colors duration-300"
  [class.hidden]="!platformService.hasWebBleSupport || showNoBleFallback()"
  [style.background-color]="unlockPageTheme().bg_color"
>
  <!-- Subtle Background Watermark -->
  @if (pageState().status === 'success') {
    <div
      class="pointer-events-none absolute inset-0 z-0 flex items-center justify-center overflow-hidden"
    >
      <svg
        viewBox="0 0 97 97"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="select-none"
        style="width: 17.05%; max-width: 87.3px; height: auto"
      >
        <path
          d="M26.192 0C11.7257 0 0 11.6876 0 26.107V96.1158H70.2366C84.7029 96.1158 96.4286 84.4281 96.4286 70.0087V0H26.192ZM44.0035 87.3413H8.74436V26.3703C8.74436 16.6832 16.626 8.82714 26.3446 8.82714H43.9976V87.3413H44.0035ZM69.9079 87.3413C60.2481 87.3413 52.4192 79.5378 52.4192 69.9093C52.4192 60.2807 60.2481 52.4773 69.9079 52.4773C79.5678 52.4773 87.3966 60.2807 87.3966 69.9093C87.3966 79.5378 79.5678 87.3413 69.9079 87.3413ZM52.337 43.8666C52.337 24.5159 68.071 8.83299 87.4847 8.83299V43.8666H52.337"
          fill="#E5E3E0"
          fill-opacity="0.5"
        />
      </svg>
    </div>
  }
  @if (pageState().status === 'loading') {
    <div
      class="relative mx-auto flex w-full max-w-lg flex-1 flex-col items-center justify-center bg-transparent"
    >
      <div class="flex flex-col items-center justify-center p-8">
        <span
          class="motion-safe:animate-rotation relative box-border inline-block h-12 w-12 rounded-full border-[3px] border-[#e2e8f0]"
          [style.--loader-color]="unlockPageTheme().loading_color"
        >
          <span
            class="absolute top-0 left-1/2 h-3 w-3 -translate-x-1/2 -translate-y-1/2 rounded-full"
            [style.background-color]="unlockPageTheme().loading_color"
            aria-hidden="true"
          ></span>
        </span>
        <p
          class="mt-4 font-sans font-medium tracking-wide"
          [style.color]="unlockPageTheme().loading_color"
        >
          Loading…
        </p>
      </div>
      @if (!isEnterprise()) {
        <!--<footer class="absolute bottom-5 w-full text-center">
      <p class="text-xs opacity-70" [style.color]="unlockPageTheme().label_color">
        Powered by <span class="font-bold tracking-wide">{{ currentPlatform() }}</span>
      </p>
    </footer>-->
      }
    </div>
  } @else if (pageState().status === 'error') {
    <div
      class="relative mx-auto flex w-full max-w-lg flex-1 flex-col items-center justify-center bg-transparent px-8"
    >
      @let state = pageState();
      <div class="motion-safe:animate-slideIn flex flex-col items-center gap-6 text-center">
        <div
          class="flex h-20 w-20 items-center justify-center rounded-full"
          [style.background-color]="themeService.hexAlpha(unlockPageTheme().error_color, 0.1)"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="36"
            height="36"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.6"
            stroke-linecap="round"
            stroke-linejoin="round"
            [style.color]="unlockPageTheme().error_color"
          >
            <path
              d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
            ></path>
            <line x1="12" y1="8" x2="12" y2="12"></line>
            <line x1="12" y1="16" x2="12.01" y2="16"></line>
          </svg>
        </div>
        <div>
          <p class="text-xl font-semibold" [style.color]="unlockPageTheme().label_color">
            Access Denied
          </p>
          <p
            class="mt-2 max-w-xs text-sm leading-relaxed"
            [style.color]="themeService.hexAlpha(unlockPageTheme().label_color, 0.6)"
          >
            {{ state.status === 'error' ? state.message : '' }}
          </p>
        </div>
      </div>
      @if (!isEnterprise()) {
        <!--<footer class="absolute bottom-5 w-full text-center">
      <p class="text-xs opacity-70" [style.color]="unlockPageTheme().label_color">
        Powered by <span class="font-bold tracking-wide">{{ currentPlatform() }}</span>
      </p>
    </footer>-->
      }
    </div>
  } @else if (pageState().status === 'expired') {
    <div
      class="relative mx-auto flex w-full max-w-lg flex-1 flex-col items-center justify-center bg-transparent px-8"
    >
      <div class="motion-safe:animate-slideIn flex flex-col items-center gap-6 text-center">
        <div
          class="flex h-20 w-20 items-center justify-center rounded-full"
          style="background-color: rgba(217, 119, 6, 0.1)"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="36"
            height="36"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.6"
            stroke-linecap="round"
            stroke-linejoin="round"
            style="color: #d97706"
          >
            <circle cx="12" cy="12" r="10"></circle>
            <polyline points="12 6 12 12 16 14"></polyline>
            <line x1="4.5" y1="19.5" x2="19.5" y2="4.5"></line>
          </svg>
        </div>
        <div>
          <p class="text-xl font-semibold" [style.color]="unlockPageTheme().label_color">
            Link Expired
          </p>
          <p
            class="mt-2 max-w-xs text-sm leading-relaxed"
            [style.color]="themeService.hexAlpha(unlockPageTheme().label_color, 0.6)"
          >
            Your access has expired. Request a new link to continue.
          </p>
        </div>
      </div>
      @if (!isEnterprise()) {
        <!--<footer class="absolute bottom-5 w-full text-center">
      <p class="text-xs opacity-70" [style.color]="unlockPageTheme().label_color">
        Powered by <span class="font-bold tracking-wide">{{ currentPlatform() }}</span>
      </p>
    </footer>-->
      }
    </div>
  } @else {
    <div class="flex min-h-0 w-full flex-1 flex-col bg-transparent transition-colors duration-300">
      <div
        #scroller
        class="mx-auto flex w-full max-w-lg flex-1 flex-col overflow-y-auto"
        (scroll)="onScroll($event)"
      >
        <!-- Sticky Header Wrapper -->
        <div
          #stickyHeader
          class="pt-safe sticky top-0 z-40 w-full flex-shrink-0 px-4 pb-2 transition-shadow duration-200"
          [style.background-color]="unlockPageTheme().bg_color"
          [style.box-shadow]="headerScrolled() ? '0 4px 12px rgba(0,0,0,0.08)' : 'none'"
        >
          <!-- Header -->
          <header class="flex items-center justify-between pt-8 pb-6">
            <div class="flex items-center gap-2.5">
              @if (imageLogo()) {
                <img
                  [src]="imageLogo()"
                  alt="Tenant Logo"
                  class="h-8 max-w-[140px] object-contain"
                />
              } @else {
                <app-igloo-logo
                  [color]="unlockPageTheme().loading_color"
                  [size]="30"
                ></app-igloo-logo>
                <div>
                  <p class="text-sm font-medium" [style.color]="cardTheme().device_name_color">
                    Smart Access
                  </p>
                  <p
                    class="text-xs"
                    [style.color]="themeService.hexAlpha(unlockPageTheme().label_color, 0.6)"
                  >
                    {{ isOfflineEnabled() ? 'Offline Enabled Access' : 'Online Only Access' }}
                  </p>
                </div>
              }
            </div>

            <div class="flex items-center gap-2">
              <div
                class="flex items-center gap-1.5 rounded-full border px-2.5 py-1.5 text-sm font-medium transition-colors duration-300"
                [style.background-color]="
                  isOnline()
                    ? themeService.hexAlpha(unlockPageTheme().success_color, 0.1)
                    : themeService.hexAlpha(unlockPageTheme().label_color, 0.08)
                "
                [style.border-color]="
                  isOnline()
                    ? themeService.hexAlpha(unlockPageTheme().success_color, 0.3)
                    : themeService.hexAlpha(unlockPageTheme().label_color, 0.2)
                "
                [style.color]="isOnline() ? successTextColor() : unlockPageTheme().label_color"
              >
                @if (isOnline()) {
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path d="M5 12.55a11 11 0 0 1 14.08 0"></path>
                    <path d="M1.42 9a16 16 0 0 1 21.16 0"></path>
                    <path d="M8.53 16.11a6 6 0 0 1 6.95 0"></path>
                    <line x1="12" y1="20" x2="12.01" y2="20"></line>
                  </svg>
                  Online
                } @else {
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <line x1="2" y1="2" x2="22" y2="22"></line>
                    <path d="M8.5 16.5a5 5 0 0 1 7 0"></path>
                    <path d="M2 8.82a15 15 0 0 1 4.17-2.65"></path>
                    <path d="M10.66 5c4.01-.36 8.14.9 11.34 3.82"></path>
                  </svg>
                  Offline
                }
              </div>
            </div>
          </header>

          <!-- Key Status Banner -->
          @if (isOfflineEnabled()) {
            <div class="mb-4">
              <app-key-status-banner
                [digitalKey]="digitalKey()"
                [keyStatus]="keyStatus()"
                [isOnline]="isOnline()"
                [nowMs]="now()"
                (refresh)="handleFetchKey()"
              >
              </app-key-status-banner>
            </div>
          }

          <!-- Valid Period -->
          @if (dataDevice().length > 0) {
            <div
              @fadeUp
              class="flex items-start gap-3 rounded-2xl border px-4 py-3 transition-colors duration-300"
              [style.background-color]="
                isWithinValidPeriod()
                  ? cardMetaBg()
                  : themeService.hexAlpha(unlockPageTheme().error_color, 0.07)
              "
              [style.border-color]="
                isWithinValidPeriod()
                  ? cardMetaBorder()
                  : themeService.hexAlpha(unlockPageTheme().error_color, 0.25)
              "
            >
              <div
                class="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-lg"
                [style.background-color]="
                  isWithinValidPeriod()
                    ? themeService.hexAlpha(unlockPageTheme().label_color, 0.1)
                    : themeService.hexAlpha(unlockPageTheme().error_color, 0.15)
                "
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="15"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  [style.color]="
                    isWithinValidPeriod()
                      ? unlockPageTheme().label_color
                      : unlockPageTheme().error_color
                  "
                >
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                  <line x1="16" y1="2" x2="16" y2="6"></line>
                  <line x1="8" y1="2" x2="8" y2="6"></line>
                  <line x1="3" y1="10" x2="21" y2="10"></line>
                </svg>
              </div>
              <div class="min-w-0 flex-1">
                <p class="font-semibold" [style.color]="unlockPageTheme().label_color">
                  Access valid period
                </p>
                <p class="mt-0.5 text-xs font-medium" [style.color]="cardTheme().date_color">
                  {{ formatDate(validPeriodStart()) }} — {{ formatDate(validPeriodEnd()) }}
                </p>
              </div>
              <span
                class="flex-shrink-0 text-sm font-medium"
                [style.color]="
                  isWithinValidPeriod()
                    ? unlockPageTheme().label_color
                    : unlockPageTheme().error_color
                "
              >
                {{ isWithinValidPeriod() ? timeRemaining() + ' left' : 'Expired' }}
              </span>
            </div>
          }

          <!-- Locks count label — lives in sticky header so it pins when scrolling -->
          <p
            class="px-0.5 pt-3 text-xs font-medium tracking-widest uppercase"
            [style.color]="themeService.hexAlpha(unlockPageTheme().label_color, 0.5)"
          >
            Locks — {{ dataDevice().length }} assigned
          </p>
        </div>

        <!-- Scrollable List of Locks pushed to bottom -->
        <div class="flex min-h-0 w-full flex-1 flex-col px-4">
          <!-- Spacer pushes locks down so they sit at the bottom -->
          <div class="min-h-6 flex-1"></div>

          <!-- Locks List -->
          <div #lockList class="shrink-0 space-y-3 pb-4">
            @if (dataDevice().length === 0) {
              <div
                @fadeIn
                class="py-10 text-center text-sm font-medium"
                [style.color]="unlockPageTheme().error_color"
              >
                {{
                  pageState().status === 'error'
                    ? 'Access Denied. Check your token.'
                    : 'No locks found for this token.'
                }}
              </div>
            } @else if (!isWithinValidPeriod()) {
              <div
                @fadeIn
                class="py-10 text-center text-sm font-medium"
                [style.color]="unlockPageTheme().error_color"
              >
                Access period has ended. Contact your administrator.
              </div>
            } @else {
              @for (lock of dataDevice(); track lock.bluetooth_id; let i = $index) {
                <div #lockCard @fadeUp [style.animation-delay]="i * 70 + 'ms'">
                  <app-lock-card
                    [card]="lock"
                    [unlockFn]="handleClick"
                    [anyUnlocking]="isAnyUnlocking()"
                    [keyStatus]="keyStatus()"
                    [isDisabled]="!isOnline() && lock.token_type === 'TOKEN_TYPE_ONLINE'"
                  ></app-lock-card>
                </div>
              }

              <!-- Server error recovery card -->
              @if (showUnlockServerError()) {
                <div
                  data-testid="server-error-recovery"
                  class="mt-2 rounded-2xl border px-4 py-4"
                  [style.border-color]="themeService.hexAlpha(unlockPageTheme().error_color, 0.25)"
                  [style.background-color]="
                    themeService.hexAlpha(unlockPageTheme().error_color, 0.05)
                  "
                >
                  <p class="text-sm font-medium" [style.color]="unlockPageTheme().label_color">
                    Something went wrong connecting to the server.
                  </p>
                  <p
                    class="mt-1 text-xs"
                    [style.color]="themeService.hexAlpha(unlockPageTheme().label_color, 0.6)"
                  >
                    This can happen if the app was previously installed. Clearing saved data may fix
                    it.
                  </p>
                  <button
                    (click)="clearSavedDataAndRetry()"
                    class="mt-3 rounded-lg px-4 py-2 text-sm font-semibold"
                    [style.background-color]="unlockPageTheme().error_color"
                    style="color: white"
                  >
                    Clear saved data & retry
                  </button>
                </div>
              }
            }
          </div>

          <!-- Footer -->
          <!--@if (!isEnterprise()) {
        <p
          class="mt-4 shrink-0 pb-6 text-center text-xs"
          [style.color]="themeService.hexAlpha(unlockPageTheme().label_color, 0.35)"
        >
          Powered by {{ currentPlatform() || 'igloo' }}
        </p>
        }-->
        </div>
      </div>

      <!-- Rotate prompt: phone in landscape with the lock list pushed out of view -->
      @if (showRotatePrompt()) {
        <div
          data-testid="rotate-prompt"
          role="alertdialog"
          aria-modal="true"
          aria-labelledby="rotate-prompt-title"
          class="fixed inset-0 z-[100] flex flex-col items-center justify-center gap-4 px-6 text-center"
          [style.background-color]="unlockPageTheme().bg_color"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.6"
            stroke-linecap="round"
            stroke-linejoin="round"
            aria-hidden="true"
            [style.color]="unlockPageTheme().label_color"
          >
            <rect x="7" y="2" width="10" height="20" rx="2"></rect>
            <line x1="11" y1="18" x2="13" y2="18"></line>
          </svg>
          <p
            id="rotate-prompt-title"
            class="text-base font-semibold"
            [style.color]="unlockPageTheme().label_color"
          >
            Please rotate your device to portrait
          </p>
          <p
            class="max-w-xs text-sm"
            [style.color]="themeService.hexAlpha(unlockPageTheme().label_color, 0.6)"
          >
            Your locks are easier to reach in portrait mode.
          </p>
        </div>
      }

      <!-- Bottom drawer: shown while a lock unlock is in progress -->
      @if (isAnyUnlocking()) {
        <div @slideUp class="fixed inset-x-0 bottom-0 z-50 mx-auto max-w-lg">
          <div
            class="rounded-t-2xl px-6 pt-4 shadow-[0_-4px_32px_rgba(0,0,0,0.12)]"
            style="padding-bottom: max(2rem, env(safe-area-inset-bottom))"
            [style.background-color]="unlockPageTheme().bg_color"
          >
            <!-- Drag handle -->
            <div
              class="mx-auto mb-5 h-1 w-10 rounded-full"
              [style.background-color]="themeService.hexAlpha(unlockPageTheme().label_color, 0.15)"
            ></div>

            <div class="flex flex-col items-center gap-4 pb-2 text-center">
              <!-- Bluetooth icon -->
              <div
                class="flex h-14 w-14 items-center justify-center rounded-full"
                style="background-color: color-mix(in srgb, var(--th-loading) 12%, transparent)"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="26"
                  height="26"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="1.6"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="animate-pulse"
                  style="color: var(--th-loading)"
                >
                  <polyline points="6.5 6.5 17.5 17.5 12 23 12 1 17.5 6.5 6.5 17.5"></polyline>
                </svg>
              </div>

              <div>
                <p class="text-base font-semibold" style="color: var(--th-device-name)">
                  Connecting to lock…
                </p>
                <p
                  class="mt-1.5 max-w-xs text-sm leading-relaxed"
                  [style.color]="themeService.hexAlpha(unlockPageTheme().label_color, 0.6)"
                >
                  Press any button on the lock to wake it.
                </p>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  }
</div>
